import React, { Component } from "react";
import { connect } from "react-redux";
import jwtDecode from "jwt-decode";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Avatar, Divider } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import moment from "moment";

import { url } from "../../../config/config";
import EditProfile from "./EditProfile";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import { useStyles } from "./Profile.css";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      currentPage: "EditProfile",
      notificationOpen: false,
      profileImage: "",
    };
  }

  componentDidMount() {
    this.decodeToken();
  }

  decodeToken = async () => {
    try {
      if (this.props.isAuth) {
        let decode = await jwtDecode(this.props.userToken);
        if (decode) {
          this.setState({
            data: decode,
          });
          const response = await Axios.get(`${url}/api/users/${decode._id}`, {
            headers: {
              "x-auth-token": this.props.userToken,
            },
          });
          if (response.data.imageUrl) {
            this.setState({
              profileImage: response.data.imageUrl,
            });
          }
        }
      } else if (this.props.isAuthor) {
        let decode = await jwtDecode(this.props.authorToken);
        if (decode) {
          const response = await Axios.get(`${url}/api/authors/${decode._id}`);
          this.setState({
            data: response.data,
          });
        }
      }
    } catch (error) {}
  };

  handleCurrentPage = (e, newValue) => {
    this.setState({
      currentPage: newValue,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        style={{ top: 80, left: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="info"
          elevation={6}
          variant="filled"
        >
          Please Wait...
        </MuiAlert>
      </SnackBar>
    );
  };

  handleConfirmMail = async (e) => {
    e.preventDefault();
    this.handleLoadingOpen();
    if (this.props.isAuth) {
      const response = await Axios.post(
        `${url}/api/email/verificationEmail`,
        null,
        {
          headers: { "x-auth-token": this.props.userToken },
        }
      );
      if (response.data.success) {
        this.props.history.push("/confirmationPage");
      }
    }
    if (this.props.isAuthor) {
      const response2 = await Axios.post(
        `${url}/api/email/author/verificationEmail`,
        null,
        {
          headers: { "x-auth-token": this.props.authorToken },
        }
      );
      if (response2.data.success) {
        this.props.history.push("/confirmationPage");
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header />
        <div className={classes.root}>
          {this.props.isAuth ? (
            <div style={{ fontSize: 25 }}>Customer's Profile</div>
          ) : (
            <div style={{ fontSize: 25 }}>Author's Profile</div>
          )}
          <Divider />
          <Grid container spacing={3} className={classes.gridContainer}>
            <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
              <Paper>
                <div
                  style={{
                    paddingTop: 10,
                    paddingBottom: 10,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {this.state.profileImage || this.state.data.imageUrl ? (
                    <Avatar style={{ width: 200, height: 200 }}>
                      <img
                        src={
                          this.state.profileImage || this.state.data.imageUrl
                        }
                        alt="ProfileImage"
                        style={{ width: 200, height: 200 }}
                      />
                    </Avatar>
                  ) : (
                    <div>Image Not Available. Upload your image</div>
                  )}
                </div>
                <Divider />

                {this.props.isAuth ? (
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Username:</b>
                    <div>
                      {this.state.data.username
                        ? this.state.data.username
                        : "Not Available"}
                    </div>
                  </ListItem>
                ) : (
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Full Name:</b>
                    <div>
                      {this.state.data.firstName} {this.state.data.middleName}
                      {this.state.data.lastName}
                    </div>
                  </ListItem>
                )}
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Email:</b>
                  <div>{this.state.data.email}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Verified:</b>
                  {this.state.data.isVerified ? (
                    <div style={{ color: "green" }}>Verified</div>
                  ) : (
                    <div
                      className={classes.linkStyle}
                      style={{ color: "red" }}
                      onClick={this.handleConfirmMail}
                    >
                      Not Verified
                    </div>
                  )}
                </ListItem>

                {this.props.isAuth ? (
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Joined Date:</b>
                    <div>{moment(this.state.data.createdAt).format("LL")}</div>
                  </ListItem>
                ) : (
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Phone:</b>
                    <div>{this.state.data.phone}</div>
                  </ListItem>
                )}
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={8} xl={8} lg={8}>
              <EditProfile />
            </Grid>
            <br />
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    userToken: state.UserReducer.token,
    isAuthor: state.AuthorReducer.isAuthor,
    authorToken: state.AuthorReducer.authorToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(Profile)));
